import { useCallback } from 'react';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { useDomainStore } from '@/store/use-domain.store';

export const useProductPageNavigation = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isTenant = useDomainStore((store) => store.isTenant);

  const pageState = searchParams.get('state');
  const pathSegments = pathname.slice(1).split('/');
  const vendorSlug = pathname.split('/')[1];

  const productIdentifier = !isTenant ? pathSegments[0] : '';
  const productId = +pathSegments[1];

  const navigateToVendor = useCallback(() => {
    router.push(`/${pathSegments[0]}`);
  }, [router, pathSegments]);

  return {
    pageState,
    pathSegments,
    vendorSlug,
    productIdentifier,
    productId,
    navigateToVendor,
    isTenant,
  };
};
